import { render, staticRenderFns } from "./EditAdmin.vue?vue&type=template&id=78d74474&scoped=true&"
import script from "./EditAdmin.vue?vue&type=script&lang=js&"
export * from "./EditAdmin.vue?vue&type=script&lang=js&"
import style0 from "./EditAdmin.vue?vue&type=style&index=0&id=78d74474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d74474",
  null
  
)

export default component.exports